const CrossSmall = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fillRule="evenodd" d="m8 8.941 4.43 4.43.941-.941L8.941 8l4.43-4.43-.941-.941L8 7.059l-4.43-4.43-.945.941L7.059 8l-4.43 4.43.941.941Zm0 0" /></svg>
)

export default CrossSmall;